import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PrinterProjectionDto, PrinterType} from "../../api/fms";

export interface FmsPrinterItem {
    label: string
    id: string
}

class FmsPrinterStore {
    get options(): FmsPrinterItem[] {
        return this._options;
    }

    private set options(value: FmsPrinterItem[]) {
        this._options = value;
    }

    get loaded(): PrinterProjectionDto[] {
        return this._loaded;
    }

    set loaded(value: PrinterProjectionDto[]) {
        this._loaded = value;
    }

    get data(): PrinterProjectionDto[] {
        return this._data;
    }

    set data(value: PrinterProjectionDto[]) {
        this._data = value;
        this.options = this.buildOptions(value)
    }

    private _data: PrinterProjectionDto[] = [];
    private _loaded: PrinterProjectionDto[] = [];
    private _options: FmsPrinterItem[] = []
    private _printerType: PrinterType

    constructor(type?: PrinterType) {
        makeAutoObservable(this)
        this._printerType = type || PrinterType.DOCUMENT
    }

    async load() {
        const result = await catchApi(async () => await api.fms.api.findPrinters({
            printer: this._printerType
        }))
        this.data = result?.data || []
        this.loaded = this.data
    }

    async find(query?: string) {
        if (!query) {
            return this.load()
        }
        const result = await catchApi(async () => await api.fms.api.findPrinters({
            printer: this._printerType,
            query
        }))
        this.data = result?.data || []
    }

    reset() {
        this.data = this.loaded
    }

    private buildOptions(data: PrinterProjectionDto[]): FmsPrinterItem[] {
        return data.map(e => ({
            label: `${e.displayName} (${e.name})`,
            id: e.printerId
        }))
    }
}

const fmsDocumentPrinterStore = new FmsPrinterStore(PrinterType.DOCUMENT)
const fmsVlogPrinterStore = new FmsPrinterStore(PrinterType.VLOG)

export {
    fmsDocumentPrinterStore,
    fmsVlogPrinterStore
}
